import React from 'react';

import { useScreenDispatch, useScreenState } from 'components/Screen';
import Select from 'components/Select';
import { useQuery } from 'query';
import { DIMENSION } from 'scenes/PerformancePage/constants';
import { dimensions } from 'scenes/PerformancePage/data/queryKeyFactory';
import { SET_DIMENSION } from 'scenes/PerformancePage/screenReducer';
import { loadDimensions } from 'scenes/PerformancePage/sources/loadDimensions';

import './index.css';

const DimensionSelect = () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const { data, isLoading, error } = useQuery(dimensions, () =>
    loadDimensions()
  );

  const handleChange = (_: any, value: number) => {
    dispatch({
      type: SET_DIMENSION,
      payload: value,
    });
  };

  return (
    <Select
      value={screenState[DIMENSION]}
      isLoading={isLoading}
      error={error}
      data={data}
      label={'Dimension'}
      placeholder={'Dimension'}
      onChange={handleChange}
      className={'dimensions-select'}
    />
  );
};
export default DimensionSelect;
